import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock, ArrowRight } from 'react-feather';
import { getPostById, getRelatedPosts, getNews } from '../data/blogData';
import './NewsPost.css';

const NewsPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [relatedNews, setRelatedNews] = useState([]);

  useEffect(() => {
    const postData = getPostById(id);
    if (postData) {
      setPost(postData);
      
      // Get related news items
      const allNews = getNews().filter(item => item.id !== parseInt(id));
      setRelatedNews(allNews.slice(0, 4));
      
      window.scrollTo(0, 0);
    }
  }, [id]);

  if (!post) {
    return (
      <div className="news-loading">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="news-post-container">
      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NewsArticle",
          "headline": post.title,
          "description": post.summary,
          "datePublished": post.date,
          "author": {
            "@type": "Person",
            "name": post.author.name
          },
          "publisher": {
            "@type": "Organization",
            "name": "Brainy AI",
            "logo": {
              "@type": "ImageObject",
              "url": "https://yourdomain.com/logo.png"
            }
          }
        })}
      </script>

      {/* Navigation Header */}
      <nav className="news-nav">
        <div className="news-nav-left">
          <button onClick={() => window.history.back()} className="news-back-btn">
            <ArrowLeft size={20} />
            Back
          </button>
        </div>
        <div className="news-nav-center">
          <div className="news-logo" onClick={() => window.location.href = '/'}>
            <span>Brainy</span>
          </div>
        </div>
        <div className="news-nav-right"></div>
      </nav>

      {/* Scrollable Content Wrapper */}
      <div className="news-content-wrapper">
        <div className="news-post-wrapper">
          <div className="news-post-content">
            {/* Header */}
            <header className="news-post-header">
              <div className="news-badge-large">Breaking News</div>

              <div className="news-post-meta">
                <div className="news-post-author">
                  <img 
                    src={post.author.avatar} 
                    alt={post.author.name} 
                    className="news-author-avatar"
                  />
                  <span className="news-author-name">{post.author.name}</span>
                </div>
                <div className="news-post-meta-items">
                  <span className="news-post-date">
                    <Calendar size={16} />
                    {post.formattedDate}
                  </span>
                  <span className="news-post-read-time">
                    <Clock size={16} />
                    {post.readTime} min read
                  </span>
                </div>
              </div>

              <h1 className="news-post-title">{post.title}</h1>

              <p className="news-post-summary">{post.summary}</p>
            </header>

            {/* Main Content */}
            <article className="news-post-article">
              <div 
                className="news-post-text"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />
            </article>

            {/* Call to Action */}
            <div className="news-post-cta">
              <div className="news-cta-content">
                <h3>Ready to Transform Your Learning?</h3>
                <p>Join thousands of learners using AI-powered education</p>
                <button 
                  onClick={() => window.location.href = '/register'} 
                  className="news-cta-btn"
                >
                  Get Started Free
                  <ArrowRight size={18} />
                </button>
              </div>
            </div>
          </div>

          {/* Sidebar with Related News */}
          <aside className="news-sidebar">
            <div className="news-sidebar-sticky">
              <h3 className="news-sidebar-title">Latest Updates</h3>
              <div className="news-sidebar-list">
                {relatedNews.map((newsItem) => (
                  <article
                    key={newsItem.id}
                    className="news-sidebar-item"
                    onClick={() => window.location.href = `/blog/${newsItem.id}`}
                  >
                    <div className="news-sidebar-item-meta">
                      <span className="news-sidebar-badge">News</span>
                      <span className="news-sidebar-date">{newsItem.formattedDate}</span>
                    </div>
                    <h4 className="news-sidebar-item-title">{newsItem.title}</h4>
                    <p className="news-sidebar-item-summary">{newsItem.summary}</p>
                    <div className="news-sidebar-item-footer">
                      <Clock size={12} />
                      <span>{newsItem.readTime} min</span>
                    </div>
                  </article>
                ))}
              </div>
              
              <button 
                onClick={() => window.location.href = '/blog'} 
                className="news-sidebar-view-all"
              >
                View All Posts
                <ArrowRight size={16} />
              </button>
            </div>
          </aside>
        </div>

        {/* Footer */}
        <footer className="news-post-footer">
          <p>&copy; {new Date().getFullYear()} Brainy AI. All rights reserved.</p>
          <div className="news-post-footer-links">
            <a href="/terms">Terms</a>
            <a href="/privacy">Privacy</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default NewsPost;

